import { Payhere, AccountCategory } from "payhere-js-sdk";
import {
  Customer,
  CurrencyType,
  PayhereCheckout,
  CheckoutParams,
} from "payhere-js-sdk";
import axios from "axios";
import { getToken, getUserId } from "auth/authenticate";
import { PAYMENT_CATEGORY } from "constants/constants";
import { useNavigate } from "react-router-dom";


export const initiatePayment = async ({
  patientData,
  userData,
  doctorData,
  appointmentId,
  onError,
  onSuccess,
  // paymentConfirmNavigate,
}) => {



  try {
    Payhere.init(
      process.env.REACT_APP_PAYHERE_ENV === "SANDBOX"
        ? process.env.REACT_APP_PAYHERE_SANDBOX_MERCHANT_ID
        : process.env.REACT_APP_PAYHERE_MERCHANT_ID,
      process.env.REACT_APP_PAYHERE_ENV === "SANDBOX"
        ? AccountCategory.SANDBOX
        : AccountCategory.LIVE
    );

    const paymentResponse = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}payment`,
      {
        orderRef: appointmentId,
        txnAmount: doctorData.displayingFee,
        category: PAYMENT_CATEGORY.APPOINTMENT,
        userId: getUserId(),
        payType: "FP",
      },
      {
        headers: { Authorization: `Bearer ${getToken()}` },
      }
    );

    

    if (paymentResponse.status !== 201) throw new Error("Payment creation failed");

    // const { paymentRef, hash } = paymentResponse.data;

    const customer = new Customer({
      first_name: patientData?.name,
      last_name: patientData?.name,
      phone: userData?.User?.phoneNumber,
      email: userData?.User?.email,
      address: patientData?.address,
      city: patientData?.district || '',
      country: "Sri Lanka",
    });


    const checkoutData = new CheckoutParams({
      // returnUrl: `${process.env.REACT_APP_FRONTEND_BASE_URL}apt-external/payment/join-consultation/:aptId/:ordTr/:usrD`,
      returnUrl: `${process.env.REACT_APP_FRONTEND_BASE_URL}apt-external/payment/join-consultation/${appointmentId}`,
      cancelUrl: `${process.env.REACT_APP_FRONTEND_BASE_URL}payment/cancel`,
      notifyUrl: `${process.env.REACT_APP_BACKEND_URL}payment/confirmation`,
      order_id: paymentResponse?.data.data.paymentRef,
      itemTitle: PAYMENT_CATEGORY.APPOINTMENT,
      currency: CurrencyType.LKR,
      amount: Math.floor(doctorData.displayingFee),
      hash: paymentResponse?.data.data.hash,
    });

    const checkout = new PayhereCheckout(customer, checkoutData, onError);
    checkout.start();


// Wait for the Payhere confirmation before invoking onSuccess
// const confirmationResponse = await new Promise((resolve, reject) => {
//   checkout.onPaymentSuccess(() => resolve(true));
//   checkout.onPaymentFailure(() => reject(new Error("Payment failed")));
// });

// if (confirmationResponse) onSuccess();
    
    onSuccess();
  } catch (error) {
    onError(error.msg);
  }
};
